// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyDsHQTRy9xYSdsf3MUvOqiiY70_iD2Qm-I",
    authDomain: "lutz-lotte-staging.firebaseapp.com",
    projectId: "lutz-lotte-staging",
    storageBucket: "lutz-lotte-staging.appspot.com",
    messagingSenderId: "225523898878",
    appId: "1:225523898878:web:4c8cb168d71741b3b748af",
    measurementId: "G-T81654601V"
  },
  functionsUrl: 'https://europe-west3-lutz-lotte-staging.cloudfunctions.net/',
  paypal: {
    client: "ATnjmBBpJ1j6vtlDYs6Fj5EPq7tLVPpdQIxQ4Uj7NoOZWfgC55igm1QyzdeuAuii-yQ4oJE_g8rx6TSC",
    environment: "PayPalEnvironmentSandbox",
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
